module.exports = __webpack_public_path__ + "static/media/mybuilder-logo.aac716df.png";